import type { ReactNode } from "react";
import { t } from "@/i18n-js/instance";
import { PageMetaData } from "@/react/components/Layout/PageMetaData";
import { useContactsSearchEnabledForMembersAndSpaces } from "@/react/hooks/useContactsSearchEnabledForMembersAndSpaces";
import { useIsConnectEnabled } from "@/react/hooks/useIsConnectEnabled";
import { useNavigationLinks } from "@circle-react-uikit/HeaderV3/NavigationBar/hooks/useNavigationLinks";
import { StandardLayout } from "../Layout/StandardLayout";
import { AudienceSearchContext } from "../shared/MemberFilters/AudienceSearchContext";
import { LeftSideProfileNavigation } from "./shared/LeftSideProfileNavigation";
import { MobileNavigationTabs } from "./shared/MobileNavigationTabs";

const bodyClassNames = "view-members-directory";

interface MemberDirectoryLayoutV2Props {
  children: ReactNode;
}

export const MemberDirectoryLayoutV2 = ({
  children,
}: MemberDirectoryLayoutV2Props) => {
  const { memberDirectoryLink } = useNavigationLinks();
  const isContactsSearchEnabled = useContactsSearchEnabledForMembersAndSpaces();

  const isConnectEnabled = useIsConnectEnabled();

  const memberDirectoryTitle =
    memberDirectoryLink?.label || t("members_directory.title");

  return (
    <AudienceSearchContext.Provider
      value={{ usage: isContactsSearchEnabled ? "contacts" : "members" }}
    >
      <StandardLayout.Body
        hasPaddingTopMobile={false}
        className="bg-primary"
        wrapperClassName="sm:mx-1"
      >
        <PageMetaData
          title={memberDirectoryTitle}
          bodyClassNames={bodyClassNames}
        />

        {isConnectEnabled && <MobileNavigationTabs />}

        <StandardLayout.Content className="!max-w-6xl md:w-fit md:!min-w-0">
          <div className="flex flex-col gap-4 md:flex-row md:gap-8">
            <div className="hidden md:flex">
              <LeftSideProfileNavigation />
            </div>
            <div className="w-full md:w-[772px]">{children}</div>
          </div>
        </StandardLayout.Content>
      </StandardLayout.Body>
    </AudienceSearchContext.Provider>
  );
};
